import React from 'react'

const Logo = ({w,h}) => {
  return (
  <>
   <div className='w-12'>
     <img src="vijay-logo.png" alt='logo'/>
     </div>

     </>
  )
}

export default Logo